module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-emailbind"
  }, [_c('navbar', {
    attrs: {
      "title": "绑定邮箱"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui-content"
  }, [_c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-first-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱地址"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-first-item",
    staticStyle: {
      "display": "flex",
      "border-bottom": "1px solid #ddd"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "name": "verifyCode",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": _vm.verifyCodeImg
    },
    on: {
      "click": _vm.refreshVerifyCodeClick
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-last-item"
  }, [_c('div', {
    staticClass: "ui-col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui-col-4 ui-align-right"
  }, [_c('email-code', {
    attrs: {
      "type": 4,
      "email": _vm.email,
      "uuid": _vm.verifyUUID,
      "verifyCode": _vm.verifyCode
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [_c('input', {
    staticClass: "submit",
    class: {
      'ui-disable': _vm.submitDisable
    },
    attrs: {
      "type": "submit",
      "value": "绑定"
    },
    on: {
      "click": _vm.bind
    }
  })])]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25bb9334!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EmailBind.vue
// module id = 549
// module chunks = 1